import React from "react";
import { BorderedButton, GradientBorderBox } from "../../../../Components";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { spliter } from "../../../../Utils/Spliter";
import { useNavigate } from "react-router-dom";
export default function ProductsCard({ data: pr }) {
  const navigate = useNavigate();
  const theme = useTheme();

  const handlePriceTitle = (vr) => {
    if (vr?.price <= 0) return "تماس بگیرید";
    if (vr?.qty <= 0) return "ناموجود";
    return Number(vr?.price)?.toLocaleString() + "  تومان";
  };
  return (
    <Stack
      onClick={() =>
        navigate(`/product-details/${pr?.code}/${pr?.variant?.[0]?.code}`)
      }
      sx={{
        width: { xs: "150px", md: "250px", xl: "350px" },
        height: { xs: "260px", md: "370px", xl: "470px" },
        // bgcolor: "#f5f5f5",
        // justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        transition: "0.3s",
        position: "relative",
        padding: { xs: ".8rem", md: "1.5rem" },
        zIndex: "10",
        // "&:hover": {
        //   transform: "scale(1.05)",
        // },
      }}
    >
      {/* image */}
      <Box
        sx={{
          width: { xs: "120px", md: "230px", xl: "290px" },
          height: { xs: "100px", md: "230px", xl: "290px" },
          borderRadius: "1.5rem",
          overflow: "hidden",
          bgcolor: "black",
        }}
      >
        <img
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          src={
            pr.image?.[0]?.file_name
              ? import.meta.env.VITE_URL + pr.image?.[0]?.file_name
              : "/Media/nimobileIcon.png"
          }
          alt={pr.image?.[0]?.alt}
          title={pr.image?.[0]?.title}
        />
      </Box>
      {/* content */}
      <Stack sx={{ py: ".5rem", gap: { xs: ".5rem", sm: "1rem" } }}>
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            height: "40px",
            fontSize: { xs: ".9rem", sm: "1rem" },
          }}
        >
          {spliter({ text: pr?.name, limit: 50, mobileLimit: 30 })}
        </Typography>
        <Typography
          sx={{
            fontSize: ".8rem",
            color: theme.palette.text.low,
            textAlign: "center",
            height: "40px",
          }}
        >
          {spliter({ text: pr?.desc, limit: 80, mobileLimit: 50 })}
        </Typography>
      </Stack>
      {/* Buttons */}
      <Stack sx={{ width: "100%", gap: ".3rem" }}>
        {/* Price */}
        <BorderedButton
          sx={{
            backgroundColor: theme.palette.primary.lowOpacity,
            width: "100%",
            color: "white",
            gap: ".5rem",
            fontSize: ".8rem",
            px: ".5rem",
          }}
          icon={false}
        >
          {handlePriceTitle(pr?.variant?.[0])}
          <ShoppingCartIcon
            sx={{
              // color: theme.palette.background.paper,
              color: "black",
              fontSize: "1.3rem",
            }}
          />
        </BorderedButton>
        {/* Add To Cart */}
        {/* <BorderedButton
          sx={{
            backgroundColor: theme.palette.background.paper,
            width: "100%",
            color: "white",
            gap: ".5rem",
            border: `2px ${theme.palette.background.default} dashed`,
          }}
        >
          افزودن به سبد خرید
        </BorderedButton> */}
      </Stack>
      <GradientBorderBox
        bgGrad="linear-gradient(
    135deg,
    #000000ff -30%,
    #313131 50%,
     #313131 130%
  )"
      />
    </Stack>
  );
}
